import { render } from "./ContactsForm.vue?vue&type=template&id=3da6ed69&scoped=true&ts=true"
import script from "./ContactsForm.vue?vue&type=script&lang=ts"
export * from "./ContactsForm.vue?vue&type=script&lang=ts"

import "./ContactsForm.vue?vue&type=style&index=0&id=3da6ed69&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da6ed69"]])

export default __exports__